const colors = {
  gray1: "#e0e0e0", // usually used for border color
  gray2: "#F4F4F6",
  gray3: "#FCFCFD",
  gray4: "#667085",
  gray5: "#EAECF0",
  white1: "#FAFAFC",
  black1: "#131E3A",
  black2: "#131E3A",
  brown1: "#B7B2A8",
  green1: "#62BF6E",
  yellow1: "#A0DEFF",
  blue1: "#357ABD",
  backgroundNavbar: "#f4f4f6",
  teal1 : '#51859A',
  // Adding gradient
  backgroundMain2: "linear-gradient(180deg, #E6FFFD, #CAEDFF)", // Example gradient name
  backgroundMain: "linear-gradient(180deg, #f8f8f9,#f8f8f9)", // Example gradient name
  backgroundMain3: "#297f97", // Example gradient name
  backgroundMainbackup: "linear-gradient(180deg, #B9E9FC, #FFFFFF)", // Example gradient name
  teal: "#51859A",
  charcoal: "#77777F",
  white: "#FFFFFF",
  slate: "#616163",
  pebble: "#9DA2A5",
  sage: "#95A5A4",
  mist: "#A9C2CF",
  sand: "#BFB7AB",
  lightGray: "#BCBEC0",
  silver: "#D1D3D4",
  azure: "#0078d4",
  darkteal: "#3f565f",
  lightteal: "#E3F4F4"
} as const;


export type Colors = typeof colors;
export default colors;
